import { Box, Skeleton } from '@mui/material';
import compliantIcon from '@root/assets/svg/Compliance_V1/e-compliant.svg';
import nonCompliantIcon from '@root/assets/svg/Compliance_V1/e-non-compliant.svg';
import nonEvaluatedIcon from '@root/assets/svg/Compliance_V1/e-non-evaluated.svg';
import notApplicableIcon from '@root/assets/svg/Compliance_V1/e-not-applicable.svg';
import { SeverityWithText } from '@root/components/bootstrapTable/badges/severity';
import Text from '@root/components/v2/ui-elements/Text';
import Tooltip from '@root/components/v2/ui-elements/Tooltip';
import { capitalizeFirstLetter } from '@root/utilities/string';

const addEllipses = input => {
  if (input.length > 600) {
    input = input.substring(0, 599) + '...';
  }
  return input;
};

export const NegativeChange = () => {
  return (
    <svg
      style={{
        transform: 'rotate(180deg)',
      }}
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.58711 3.76592L5.98011 0.382145C5.43697 -0.127382 4.5596 -0.127382 4.01646 0.382144L0.409459 3.76592C-0.467918 4.589 0.15878 6 1.39825 6L8.61224 6C9.85171 6 10.4645 4.589 9.58711 3.76592Z"
        fill="#FF6A7C"
      />
    </svg>
  );
};

export const PositiveChange = () => {
  return (
    <svg
      style={{
        transform: 'rotate(180deg)',
      }}
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.412893 2.23408L4.01989 5.61786C4.56303 6.12738 5.44041 6.12738 5.98354 5.61786L9.59054 2.23408C10.4679 1.411 9.84122 0 8.60175 0H1.38776C0.148287 0 -0.464485 1.411 0.412893 2.23408Z"
        fill="#A5D6A7"
      />
    </svg>
  );
};

export const NoChange = () => {
  return (
    <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.2341 9.58711L13.6179 5.98011C14.1274 5.43697 14.1274 4.55959 13.6179 4.01646L10.2341 0.409459C9.411 -0.467918 8 0.15878 8 1.39825L8 8.61224C8 9.85171 9.411 10.4645 10.2341 9.58711Z"
        fill="#AFB1C1"
      />
      <path
        d="M3.76592 9.58711L0.382145 5.98011C-0.127381 5.43697 -0.127381 4.55959 0.382145 4.01646L3.76592 0.409459C4.589 -0.467918 6 0.15878 6 1.39825L6 8.61224C6 9.85171 4.589 10.4645 3.76592 9.58711Z"
        fill="#AFB1C1"
      />
    </svg>
  );
};

export const NegativeArrowChange = () => {
  return (
    <svg
      style={{
        transform: 'rotate(180deg)',
      }}
      width="43"
      height="43"
      viewBox="0 0 43 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M-9.39795e-07 21.5C-7.53921e-07 25.7523 1.26095 29.9091 3.6234 33.4448C5.98585 36.9804 9.34369 39.7361 13.2723 41.3634C17.2009 42.9907 21.5238 43.4165 25.6944 42.5869C29.865 41.7573 33.696 39.7096 36.7028 36.7028C39.7096 33.696 41.7573 29.865 42.5869 25.6944C43.4165 21.5238 42.9907 17.2009 41.3634 13.2723C39.7361 9.34369 36.9804 5.98585 33.4448 3.6234C29.9091 1.26095 25.7523 -1.12567e-06 21.5 -9.39795e-07C15.7998 0.00625923 10.3348 2.27344 6.30412 6.30412C2.27344 10.3348 0.00625874 15.7998 -9.39795e-07 21.5ZM41.28 21.5C41.28 25.4121 40.1199 29.2364 37.9465 32.4892C35.773 35.742 32.6838 38.2772 29.0695 39.7743C25.4552 41.2714 21.4781 41.6631 17.6411 40.8999C13.8042 40.1367 10.2797 38.2528 7.51343 35.4866C4.74714 32.7203 2.86328 29.1958 2.10007 25.3589C1.33685 21.5219 1.72856 17.5448 3.22566 13.9305C4.72276 10.3162 7.25801 7.22698 10.5108 5.05353C13.7636 2.88008 17.5879 1.72 21.5 1.72C26.7442 1.72569 31.772 3.81148 35.4803 7.51971C39.1885 11.2279 41.2743 16.2558 41.28 21.5ZM20.8915 12.2915C20.9714 12.2116 21.0663 12.1482 21.1707 12.1049C21.2751 12.0616 21.387 12.0393 21.5 12.0393C21.613 12.0393 21.7249 12.0616 21.8293 12.1049C21.9337 12.1482 22.0286 12.2116 22.1084 12.2915L28.9884 19.1715C29.1498 19.3329 29.2405 19.5518 29.2405 19.78C29.2405 20.0082 29.1498 20.2271 28.9884 20.3884C28.8271 20.5498 28.6082 20.6405 28.38 20.6405C28.1518 20.6405 27.9329 20.5498 27.7715 20.3884L22.36 14.9769L22.36 30.1C22.36 30.3281 22.2694 30.5468 22.1081 30.7081C21.9468 30.8694 21.7281 30.96 21.5 30.96C21.2719 30.96 21.0532 30.8694 20.8919 30.7081C20.7306 30.5468 20.64 30.3281 20.64 30.1L20.64 14.9769L15.2284 20.3884C15.0671 20.5498 14.8482 20.6405 14.62 20.6405C14.3918 20.6405 14.1729 20.5498 14.0115 20.3884C13.8502 20.2271 13.7595 20.0082 13.7595 19.78C13.7595 19.5518 13.8502 19.3329 14.0115 19.1715L20.8915 12.2915Z"
        fill="#FF6A7C"
      />
    </svg>
  );
};

export const PositiveArrowChange = () => {
  return (
    <svg
      style={{
        transform: 'rotate(180deg)',
      }}
      width="43"
      height="43"
      viewBox="0 0 43 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 21.5C1.85874e-07 17.2477 1.26095 13.0909 3.6234 9.55525C5.98585 6.01959 9.34369 3.26388 13.2723 1.6366C17.2009 0.00931525 21.5238 -0.416456 25.6944 0.413126C29.865 1.24271 33.696 3.29039 36.7028 6.29721C39.7096 9.30404 41.7573 13.135 42.5869 17.3056C43.4165 21.4762 42.9907 25.7991 41.3634 29.7277C39.7361 33.6563 36.9804 37.0141 33.4447 39.3766C29.9091 41.739 25.7523 43 21.5 43C15.7998 42.9937 10.3348 40.7266 6.30411 36.6959C2.27344 32.6652 0.00625968 27.2002 0 21.5ZM41.28 21.5C41.28 17.5879 40.1199 13.7636 37.9465 10.5108C35.773 7.25803 32.6838 4.72277 29.0695 3.22567C25.4551 1.72857 21.4781 1.33686 17.6411 2.10008C13.8042 2.86329 10.2797 4.74715 7.51343 7.51344C4.74714 10.2797 2.86328 13.8042 2.10007 17.6411C1.33685 21.4781 1.72856 25.4552 3.22566 29.0695C4.72276 32.6838 7.25801 35.773 10.5108 37.9465C13.7636 40.1199 17.5879 41.28 21.5 41.28C26.7442 41.2743 31.772 39.1885 35.4803 35.4803C39.1885 31.7721 41.2743 26.7442 41.28 21.5ZM20.8915 30.7085C20.9714 30.7884 21.0663 30.8518 21.1707 30.8951C21.2751 30.9384 21.387 30.9607 21.5 30.9607C21.613 30.9607 21.7249 30.9384 21.8293 30.8951C21.9337 30.8518 22.0286 30.7884 22.1084 30.7085L28.9884 23.8285C29.1498 23.6671 29.2405 23.4482 29.2405 23.22C29.2405 22.9918 29.1498 22.7729 28.9884 22.6116C28.8271 22.4502 28.6082 22.3595 28.38 22.3595C28.1518 22.3595 27.9329 22.4502 27.7715 22.6116L22.36 28.0231V12.9C22.36 12.6719 22.2694 12.4532 22.1081 12.2919C21.9468 12.1306 21.7281 12.04 21.5 12.04C21.2719 12.04 21.0532 12.1306 20.8919 12.2919C20.7306 12.4532 20.64 12.6719 20.64 12.9V28.0231L15.2284 22.6116C15.0671 22.4502 14.8482 22.3595 14.62 22.3595C14.3918 22.3595 14.1729 22.4502 14.0115 22.6116C13.8502 22.7729 13.7595 22.9918 13.7595 23.22C13.7595 23.4482 13.8502 23.6671 14.0115 23.8285L20.8915 30.7085Z"
        fill="#A5D6A7"
      />
    </svg>
  );
};

export const NoArrowChange = () => {
  return (
    <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_13556_458956)">
        <path
          d="M24.4992 27.7C24.2992 27.9 24.2992 28.1 24.2992 28.3C24.2992 28.6 24.3992 28.8 24.5992 28.9C24.7992 29.1 24.9992 29.2 25.1992 29.2C25.3992 29.2 25.6992 29.1 25.7992 28.9L32.5992 22.1C32.6992 22 32.7992 21.9 32.7992 21.8C32.7992 21.7 32.8992 21.6 32.8992 21.4C32.8992 21.3 32.8992 21.2 32.7992 21.1C32.7992 21 32.6992 20.9 32.5992 20.8L25.6992 14C25.4992 13.8 25.2992 13.7 25.0992 13.7C24.7992 13.7 24.5992 13.8 24.4992 14C24.2992 14.2 24.1992 14.4 24.1992 14.6C24.1992 14.9 24.2992 15.1 24.3992 15.2L30.6992 21.4L24.4992 27.7Z"
          fill="#AFB1C1"
        />
        <path
          d="M18.4996 27.7001C18.6996 27.9001 18.6996 28.1001 18.6996 28.3001C18.6996 28.6001 18.5996 28.8001 18.3996 28.9001C18.1996 29.1001 17.9996 29.2001 17.7996 29.2001C17.5996 29.2001 17.2996 29.1001 17.1996 28.9001L10.3996 22.1001C10.2996 22.0001 10.1996 21.9001 10.1996 21.8001C10.1996 21.7001 10.0996 21.6001 10.0996 21.4001C10.0996 21.3001 10.0996 21.2001 10.1996 21.1001C10.1996 21.0001 10.2996 20.9001 10.3996 20.8001L17.1996 13.9001C17.3996 13.7001 17.5996 13.6001 17.7996 13.6001C18.0996 13.6001 18.2996 13.7001 18.3996 13.9001C18.5996 14.1001 18.6996 14.3001 18.6996 14.5001C18.6996 14.8001 18.5996 15.0001 18.4996 15.1001L12.1996 21.3001L18.4996 27.7001Z"
          fill="#AFB1C1"
        />
        <path
          d="M0 21.5C0 17.2 1.3 13.1 3.6 9.60001C6 6.00001 9.3 3.30001 13.3 1.60001C17.2 1.0848e-05 21.6 -0.499989 25.7 0.400011C29.9 1.20001 33.7 3.30001 36.7 6.30001C39.7 9.30001 41.8 13.1 42.6 17.3C43.4 21.5 43 25.8 41.4 29.7C39.8 33.6 37 37 33.4 39.4C29.9 41.8 25.7 43 21.5 43C15.8 43 10.3 40.7 6.3 36.7C2.3 32.7 0 27.2 0 21.5ZM41.3 21.5C41.3 17.6 40.1 13.8 38 10.5C35.8 7.20001 32.7 4.70001 29.1 3.20001C25.5 1.70001 21.5 1.30001 17.7 2.10001C13.9 2.90001 10.3 4.70001 7.6 7.50001C4.8 10.3 2.9 13.8 2.2 17.6C1.4 21.4 1.8 25.4 3.3 29C4.8 32.6 7.3 35.7 10.6 37.9C13.9 40.1 17.7 41.2 21.6 41.2C26.8 41.2 31.9 39.1 35.6 35.4C39.2 31.8 41.3 26.7 41.3 21.5Z"
          fill="#AFB1C1"
        />
      </g>
      <defs>
        <clipPath id="clip0_13556_458956">
          <rect width="43" height="43" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const environment = {
  data: {
    environments: [
      {
        account_id: '464989065112',
        scan_id: '464911236004',
        environment_tags: '["Production"]',
        non_compliant_count: 947,
        non_evaluated_count: 0,
        compliant_count: 329,
      },
      {
        account_id: '782681689401',
        scan_id: '782611239621',
        environment_tags: '["Production"]',
        non_compliant_count: 1682,
        non_evaluated_count: 0,
        compliant_count: 550,
      },
    ],
    total_environments: 2,
  },
};

export const overTimeGraph = [
  {
    scan_date: '2025-03-09T08:45:02.718540+00:00',
    scores: {
      average_score: 0,
    },
    no_scan: true,
  },
  {
    scan_date: '2025-03-09T13:56:10+00:00',
    scores: {
      average_score: 0,
    },
    no_scan: true,
  },
  {
    scan_date: '2025-03-10T05:13:05+00:00',
    scores: {
      average_score: 0,
    },
    no_scan: true,
  },
  {
    scan_date: '2025-03-10T08:45:02.688951+00:00',
    scores: {
      average_score: 0,
    },
    no_scan: true,
  },
];

export const averageScore = {
  data: {
    average_score: 0,
    change: -1,
    last_week_score_change: 15,
    difference: 'Last 24 hours',
  },
};
export const columns = [
  {
    field: 'compliance',
    headerName: 'Compliance',
    cellClassName: 'align-middle',
    sortable: false,
    // flexGrow: 1,
    minWidth: 200,
    renderCell: params => {
      return (
        <Text
          font="medium"
          fontSize={'13px'}
          className="SingleLine"
          style={{
            overflowWrap: 'break-word',
            hyphens: 'auto',
            // margin: '10px',
          }}>
          {params.row.compliance === 'AWS-Well-Architected_v2020-07-02'
            ? 'AWAF_v2020-07-02'
            : params.row.compliance === 'Google Cloud Architecture Framework'
            ? 'GCAF'
            : params.row.compliance}
        </Text>
      );
    },
  },

  {
    field: 'control',
    headerName: 'Control ID',
    classes: 'align-middle',
    // headerClassName: 'fs__2'
    minWidth: 150,
    sort: true,
    renderCell: params => {
      return (
        <Tooltip title={params.row.control} isIcon={true}>
          <Text
            font="medium"
            fontSize={'13px'}
            className="SingleLine"
            style={{
              overflowWrap: 'break-word',
              hyphens: 'auto',
              // margin: '10px',
            }}>
            {params.row.control}
          </Text>
        </Tooltip>
      );
    },
  },
  {
    field: 'control_description',
    headerName: 'Control Description',
    classes: 'align-middle',
    // headerClassName: 'fs__2'
    width: 400,
    sort: true,
    renderCell: params => {
      return (
        <Tooltip title={params.row.control_description} isIcon={true}>
          <Text
            font="medium"
            className="SingleLine"
            // style={{
            //   overflowWrap: 'break-word',
            //   wordWrap: 'break-word',
            //   hyphens: 'auto',
            //   whiteSpace: 'normal',
            //   margin: '10px',
            // }}
            style={{
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'normal',
              WebkitLineClamp: 3,
              // margin: '10px',
            }}>
            {addEllipses(params.row.control_description)}
          </Text>
        </Tooltip>
      );
    },
  },
  {
    field: 'control_domain',
    headerName: 'Control Domain',
    classes: 'align-middle',
    // headerClassName: 'fs__2'
    width: 400,
    sort: true,
    renderCell: params => {
      return (
        <Tooltip title={params.row.control_domain} isIcon={true}>
          <Text
            font="medium"
            className="SingleLine"
            // style={{
            //   overflowWrap: 'break-word',
            //   wordWrap: 'break-word',
            //   hyphens: 'auto',
            //   whiteSpace: 'normal',
            //   margin: '10px',
            // }}
            style={{
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'normal',
              WebkitLineClamp: 3,
              // margin: '10px',
            }}>
            {addEllipses(params.row.control_domain ? params.row.control_domain : '-')}
          </Text>
        </Tooltip>
      );
    },
  },
  {
    field: 'control_title',
    headerName: 'Control Title',
    classes: 'align-middle',
    // headerClassName: 'fs__2'
    width: 400,
    sort: true,
    renderCell: params => {
      return (
        <Tooltip title={params.row.control_title} isIcon={true}>
          <Text
            font="medium"
            className="SingleLine"
            // style={{
            //   overflowWrap: 'break-word',
            //   wordWrap: 'break-word',
            //   hyphens: 'auto',
            //   whiteSpace: 'normal',
            //   margin: '10px',
            // }}
            style={{
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'normal',
              WebkitLineClamp: 3,
              // margin: '10px',
            }}>
            {addEllipses(params.row.control_title ? params.row.control_title : '-')}
          </Text>
        </Tooltip>
      );
    },
  },
  {
    field: 'evaluation',
    headerName: 'Evaluation',
    classes: 'align-middle',
    // headerClassName: 'fs__2'
    minWidth: 180,
    // sort: true,
    renderCell: params => {
      return (
        <Tooltip title={params.row.evaluation} isIcon={true}>
          <img
            src={
              params.row.evaluation === 'compliant'
                ? compliantIcon
                : params.row.evaluation === 'non-compliant'
                ? nonCompliantIcon
                : params.row.evaluation === 'non-evaluated'
                ? nonEvaluatedIcon
                : notApplicableIcon
            }
          />
        </Tooltip>
      );
    },
  },
  {
    field: 'severity',
    headerName: 'Severity',
    classes: 'align-middle',
    // headerClassName: 'fs__2'
    minWidth: 180,
    // sort: true,
    renderCell: params => {
      return <SeverityWithText propsValue={params.row.severity} />;
    },
  },
];

export const controlTest = {
  status: 200,
  data: {
    control_test: {
      pass_controls: 3,
      fail_controls: 59,
      total_controls: 64,
      not_applicable_controls: 2,
    },
  },
  type: 'json',
  error: 0,
  msg: 'success',
};

export const TopRowSkeleton = () => {
  return (
    <div
      style={{
        // overflowY: 'auto',
        height: '170px',
        display: 'flex',
        // flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      className="compliance--metric"
      id="average-score">
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '90%',
        }}>
        <Skeleton height="50px" width="100%" style={{ transform: 'none' }} />
        <div
          className="average--score--right--container"
          style={{
            alignItems: 'center',
            display: 'none',
          }}>
          <Skeleton height="50px" width="120px" style={{ transform: 'none' }} />
        </div>
      </div>
    </div>
  );
};

export const ControlTestSkeleton = () => {
  return (
    <div
      style={{
        height: '170px',
        fontFamily: 'Manrope',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        gap: '20px',
      }}>
      <Skeleton variant="circular" height="88px" width="88px" style={{ transform: 'none' }} />
      <div>
        <Skeleton height="20px" width="50px" style={{ transform: 'none', marginBottom: '10px' }} />{' '}
        <Skeleton height="20px" width="50px" style={{ transform: 'none' }} />
      </div>
    </div>
  );
};
export const EnvSkeleton = () => {
  return (
    <div
      style={{
        height: '160px',
        padding: '0px 15px',
        // padding: '10px',
      }}>
      {[0, 1, 2].map((element, index) => (
        <div
          key={index}
          style={{
            // paddingTop: '10px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            margin: '10px 5px',
            fontFamily: 'Manrope',
          }}>
          <div
            style={{
              display: 'flex',
            }}>
            <Skeleton height="43px" width="100px" style={{ transform: 'none' }} />
          </div>

          <div
            style={{
              display: 'flex',
            }}>
            <Skeleton height="43px" width="100px" style={{ transform: 'none' }} />
          </div>
        </div>
      ))}
    </div>
  );
};

export const ComplianceTrendsSkeleton = () => {
  return (
    <Box marginLeft="15px" marginRight="15px" marginBottom="15px" marginTop="15px">
      <Skeleton height="140px" width="100%" style={{ transform: 'none' }} />
    </Box>
  );
};

export const LegendRow = ({ label, count, color, first = false, isTable = false }) => {
  return (
    <Box display="flex" flexDirection="row" alignItems="center" marginBottom={first ? '8px' : '15px'}>
      <Box
        width="10px"
        height="10px"
        marginRight="8px"
        borderRadius="50%"
        sx={{
          backgroundColor: color || '#ccc',
        }}
        component="div"
      />
      {isTable ? (
        <Box display={'flex'} alignItems={'center'} gap={'4px'}>
          <Text fontWeight={500}>{count}</Text>
          <Text fontWeight={500} color={'#484D56'}>
            {label}
          </Text>
        </Box>
      ) : (
        <>
          <Text fontWeight={500} color={'#484D56'}>
            {label}
          </Text>
          <Box flexGrow={1} />
          <Text fontWeight={500}>{count}</Text>
        </>
      )}
    </Box>
  );
};
// workload vulnerability -> container
// cluster vulnerability -> cve vulnerability

export const ProfileStatusCard = ({ label, data, tooltipData }) => {
  // Define color schemes based on label values

  const getColorScheme = labelText => {
    const label = labelText.toLowerCase();
    if (label === 'partial') {
      // "Partial" status: yellow-brownish background and icon
      return {
        bg: '#FFF4D6',
        icon: '#D4A438', // golden yellow-brown
        iconType: 'warning',
      };
    }
    if (label === 'completed' || label === 'complete' || label === 'finished') {
      return {
        bg: '#D8ECD8',
        icon: '#5C9250', // deeper green
        iconType: 'check',
      };
    }

    if (
      label === 'optimized' ||
      label === 'optimised' ||
      label === 'connected' ||
      label === 'onboarded' ||
      label === 'success' ||
      label === 'scanned' ||
      label === 'enabled' ||
      label === 'integrated' ||
      label === 'healthy' ||
      label === 'running' ||
      label === 'deny' ||
      label === 'active' ||
      label === 'finished' ||
      label === 'approved' ||
      label === 'permissive'
    ) {
      return {
        bg: '#D8ECD8',
        icon: '#5C9250', // deeper green
        iconType: 'check',
      };
    } else if (
      label === 'missing' ||
      label === 'not connected' ||
      label === 'not onboarded' ||
      label === 'unscanned' ||
      label === 'review_status' ||
      label === 'not scanned' ||
      label === "immediate" ||
      label === 'not integrated' ||
      label === 'fail' ||
      label === 'disabled' ||
      label === 'high' ||
      label === 'failed' ||
      label === 'cancelled' ||
      label === 'terminated' ||
      label === 'enforce' ||
      label === 'deleted' ||
      label === 'killed' ||
      label === "notsecure" ||
      label === 'remove' ||
      label === 'removed' ||
      label === 'inactive' ||
      label === 'restricted' ||
      label === 'forbidden'
    ) {
      return {
        bg: '#FFD9D9',
        icon: '#D84545', // vibrant deep red
        iconType: 'error',
      };
    } else if (
      label === 'pending' ||
      label === 'overly permissive' ||
      label === 'quarantine' ||
      label === 'sent' ||
      label === 'monitor' ||
      label === 'in-progress' ||
      label === 'queued' ||
      label === 'low' ||
      label === 'medium' ||
      label === 'degraded' ||
      label === 'learning' ||
      label === 'warn'
    ) {
      return {
        bg: '#FFF4D6',
        icon: '#D4A438', // golden yellow-brown
        iconType: 'warning',
      };
    } else if (label === 'dryrun') {
      return {
        bg: '#CCE5FF',
        icon: '#5AB3FF', // golden yellow-brown
        iconType: 'progress',
      };
    } else {
      // Default scheme for other statuses
      return {
        bg: '#B4BFC9',
        icon: '#2E333B',
        iconType: 'info',
      };
    }
  };

  // Get colors for this specific label
  const colorScheme = getColorScheme(label);

  // Render appropriate icon based on type
  const renderIcon = iconType => {
    const iconStyle = {
      width: '12px',
      height: '12px',
      stroke: colorScheme.icon,
      strokeWidth: 2,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      fill: 'none',
    };

    switch (iconType) {
      case 'check':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={iconStyle}>
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
            <path d="M9 12l2 2 4-4" />
          </svg>
        );
      case 'error':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={iconStyle}>
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
            <path d="M9 9l6 6" />
            <path d="M15 9l-6 6" />
          </svg>
        );
      case 'warning':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={iconStyle}>
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
            <path d="M9 12l2 2 4-4" />
          </svg>
        );
      default:
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={iconStyle}>
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="16" x2="12" y2="12" />
            <line x1="12" y1="8" x2="12.01" y2="8" />
          </svg>
        );
    }
  };

  const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    padding: '2px 8px',
    borderRadius: '8px',
    backgroundColor: colorScheme.bg,
    width: 'fit-content',
  };

  const iconContainerStyle = {
    marginRight: '4px',
    display: 'flex',
  };

  const textStyle = {
    fontSize: '11px',
    fontWeight: 500,
    color: colorScheme.icon,
  };

  return (
    <>
      {!data ? (
        <Tooltip title={tooltipData} isIcon={true}>
          <div style={containerStyle}>
            <span style={iconContainerStyle}>{renderIcon(colorScheme.iconType)}</span>
            <span style={textStyle}>{capitalizeFirstLetter(label)}</span>
          </div>
        </Tooltip>
      ) : (
        <Tooltip
          title={
            data.status ? (
              <div style={{ padding: '10px' }}>
                <ul style={{ margin: '0px', padding: '0px', listStyleType: 'none' }}>
                  {data.integratedList.map(item => {
                    return (
                      <li style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: '8px' }}>{renderIcon('check')}</span>
                        <span>{item}</span>
                      </li>
                    );
                  })}
                </ul>
              </div>
            ) : (
              ''
            )
          }
          isIcon={true}>
          <div style={containerStyle}>
            <span style={iconContainerStyle}>{renderIcon(colorScheme.iconType)}</span>
            <span style={textStyle}>{capitalizeFirstLetter(label)}</span>
          </div>
        </Tooltip>
      )}
    </>
  );
};
